import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ContainedButton } from 'components/ContainedButton';
import React from 'react';
import { useTranslation } from 'react-i18next';

type OptionsProps = {
  onSave: () => void;
  isLoading: boolean;
};

const useStyles = makeStyles((theme: any) => ({
  container: {
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      '& button': {
        width: '100%',
      },
    },
  },
}));

export const Options = ({ onSave, isLoading }: OptionsProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <ContainedButton text={t('common:save')} icon="hdd" onClick={onSave} isLoading={isLoading} />
    </Box>
  );
};
